import type { Card } from '../../shared/doc.js';
import { updateCard } from '../../shared/ops.js';
import type { ProjectConn } from '../doc/useProject.js';

type Palette = Extract<Card, { kind: 'palette' }>;

export function PaletteCard({ conn, card, editing }: { conn: ProjectConn; card: Palette; editing: boolean }) {
  const save = (colours: Palette['colours']) => updateCard(conn.doc, conn.me, card.id, { colours });
  if (!editing) {
    return (
      <div className="palette">
        {card.colours.map((c, i) => (
          <div key={i} className="swatch" style={{ background: c.hex }} title={c.name || c.hex}>
            <span>{c.name || c.hex}</span>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="palette editing" onPointerDown={(e) => e.stopPropagation()}>
      {card.colours.map((c, i) => (
        <div key={i} className="swatch-edit">
          <input type="color" aria-label={`Colour ${i + 1}`} value={c.hex} onChange={(e) => save(card.colours.map((x, j) => (j === i ? { ...x, hex: e.target.value } : x)))} />
          <input aria-label={`Colour ${i + 1} name`} value={c.name} placeholder="name" onChange={(e) => save(card.colours.map((x, j) => (j === i ? { ...x, name: e.target.value.slice(0, 40) } : x)))} />
          {card.colours.length > 1 && (
            <button className="link small" aria-label={`Remove colour ${i + 1}`} onClick={() => save(card.colours.filter((_, j) => j !== i))}>
              ×
            </button>
          )}
        </div>
      ))}
      {card.colours.length < 8 && (
        <button className="link small" onClick={() => save([...card.colours, { hex: '#999999', name: '' }])}>
          + colour
        </button>
      )}
    </div>
  );
}
